import { ListLayout } from '@ingrid/luterkort-react';

import { useTranslatedFormLabel } from '../hooks';
import { Schema } from '../queries';

interface Props {
  schema: Schema;
  path?: string;
}

export function SchemaDisplayNumber({ schema, path = '' }: Props) {
  const label = useTranslatedFormLabel({ path });

  if (schema.type !== 'number') {
    return null;
  }

  return (
    <ListLayout.Stack>
      <ListLayout.SecondaryText>{label}</ListLayout.SecondaryText>
      <ListLayout.PrimaryText>{schema.value ?? '-'}</ListLayout.PrimaryText>
    </ListLayout.Stack>
  );
}
